import React from "react";
import { CheckIcon, ChevronRightIcon } from "lucide-react";
import { volumes, decisionLevels, protocolSteps, images } from "../../data/content";
import { SectionCta } from "../SectionCta";
const toneClasses: Record<string, string> = {
  accept: "bg-accept text-white",
  prepare: "bg-prepare text-ink",
  refer: "bg-refer text-white"
};
export function Volumes() {
  return <section className="w-full bg-navy px-4 py-16 text-white sm:py-20" data-id="element-311" data-mp="2o0bp3rggjupc">
      <div className="mx-auto max-w-3xl" data-id="element-312" data-mp="2o2oid0ro1rhp">
        <h2 className="text-center font-serif text-3xl font-black leading-tight sm:text-4xl" data-id="element-313" data-mp="2j9d9yv77h2no">
          What you'll find inside <em className="text-[#5aa2ff]" data-id="element-314" data-mp="2ebtqngvnhzov">Implant Case Decision™</em>
        </h2>
        <p className="mt-3 text-center text-[17px] text-white/75" data-id="element-315" data-mp="29c7dt8jqilgl">Six volumes that build on each other — one decision layer at a time.</p>

        <img src={images.mockup} alt="The 6 volumes of Implant Case Decision" className="mx-auto mt-8 w-full max-w-xl" data-id="element-316" data-mp="259kgis4ao8c0" />

        <ol className="mt-10 space-y-5" data-id="element-317" data-mp="20ddcj4vgl6wp">
          {volumes.map(v => <li key={v.number} className="rounded-3xl bg-white p-6 text-ink sm:p-7" data-id="element-318" data-mp="3342v3aictsg3">
              <div className="flex items-center gap-3" data-id="element-319" data-mp="37x4ffy1byk72">
                <span className="flex h-12 min-w-[48px] items-center justify-center rounded-xl bg-brand px-2 font-serif text-xl font-black text-white" data-id="element-320" data-mp="2u57t6amcf4il">
                  {v.number}
                </span>
                <span className="text-sm font-bold uppercase tracking-wide text-brand" data-id="element-321" data-mp="3lwdmo87k63yw">Volume {v.number}</span>
              </div>
              <h3 className="mt-4 font-serif text-2xl font-black leading-tight" data-id="element-322" data-mp="3qtx9hwibnp2g">{v.title}</h3>
              <p className="mt-1 font-semibold text-muted" data-id="element-323" data-mp="3cue3paczgptb">{v.subtitle}</p>
              <p className="mt-3 text-[16px] leading-relaxed text-muted" data-id="element-324" data-mp="3hu0r2cmizmfu">{v.body}</p>

              {v.points.length > 0 && <ul className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-325" data-mp="21fhb5qhlbih7">
                  {v.points.map(pt => <li key={pt} className="flex items-start gap-2 text-[15px] font-medium" data-id="element-326" data-mp="26goijoftmfnc">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accept" strokeWidth={3} aria-hidden="true" data-id="element-327" data-mp="byn780t8mmoq" />
                      {pt}
                    </li>)}
                </ul>}

              {v.number === "V" && <div className="mt-5 space-y-2.5" data-id="element-328" data-mp="3udxr2qfclzyl">
                  {decisionLevels.map(d => <div key={d.label} className="flex items-start gap-3 rounded-xl bg-canvas p-3" data-id="element-329" data-mp="3pebbiac1s7mm">
                      <span className={`shrink-0 rounded-lg px-2.5 py-1 text-xs font-black tracking-wide ${toneClasses[d.tone]}`} data-id="element-330" data-mp="3keoxhyoeancr">{d.label}</span>
                      <p className="text-[15px] leading-snug text-muted" data-id="element-331" data-mp="3fhy8umyiyjfq">{d.text}</p>
                    </div>)}
                </div>}

              {v.number === "VI" && <div className="mt-5 flex flex-wrap items-center gap-1.5" data-id="element-332" data-mp="1dm62ljk5j6av">
                  {protocolSteps.map((s, i) => <React.Fragment key={s} data-id="element-333" data-mp="2rks9pwwwibii" data-mpi={i}>
                      <span className={`rounded-lg px-2.5 py-1.5 text-xs font-bold uppercase ${i === protocolSteps.length - 1 ? "bg-accept text-white" : "bg-brand-light text-brand-dark"}`} data-id="element-334" data-mp="2rk0kd3twda0o">
                        {s}
                      </span>
                      {i < protocolSteps.length - 1 && <ChevronRightIcon className="h-3.5 w-3.5 text-muted" aria-hidden="true" data-id="element-335" data-mp="28mpnfpvqmsoe" />}
                    </React.Fragment>)}
                </div>}
            </li>)}
        </ol>

        <SectionCta dark label="I want to decide every case with confidence" data-id="element-336" data-mp="2hl1bpl94tedo" />
      </div>
    </section>;
}